import { VehicleReportItem } from '@vromo/api/reportsApi';
import { RootStore } from '@vromo/dashboard/src/stores/RootStore';
import { useStore } from '@vromo/mobx-react/mobx-react';
import React, { memo } from 'react';
import { CellCenter, CellRight } from '../Components';
import convertDistance from '@vromo/utils/convertDistance';

const formatNumber = (value: number) => value?.toFixed(2);

const DriverRow = memo(
    ({
        id,
        driver,
        groupId,
        totalAvailabilityHours,
        timeOnJob,
        totalTravel,
        offJobTravel,
        onJobTravel,
        avgRating,
        payEstimate,
        costPerJob,
        jobsCompleted,
        jobsCancelled,
        jobsReOffered
    }: VehicleReportItem) => {
        const { groupStore, viewStore } = useStore<RootStore>('rootStore');
        const vehicleContact = driver?.contact || { name: 'Unknown', email: 'Unknown' };
        const groupName = groupStore.withId(groupId)?.name;
        const distance = (amount: number) =>
            convertDistance(amount, viewStore.imperialUnits).distance().toFixed(2);

        return (
            <tr key={id}>
                <td>{vehicleContact?.name || vehicleContact?.email}</td>
                <td>{groupName}</td>
                <CellCenter>{formatNumber(totalAvailabilityHours)}</CellCenter>
                <CellRight>{formatNumber(timeOnJob)}</CellRight>
                <CellRight>{jobsCompleted}</CellRight>
                <CellRight>{jobsCancelled}</CellRight>
                <CellRight>{jobsReOffered}</CellRight>
                <CellRight>{distance(totalTravel)}</CellRight>
                <CellRight>{distance(onJobTravel)}</CellRight>
                <CellRight>{distance(offJobTravel)}</CellRight>
                <CellRight>{avgRating ? `${(avgRating * 5).toFixed(1)} / 5` : 'N/A'}</CellRight>
                <CellRight>{formatNumber(payEstimate)}</CellRight>
                <CellRight>{formatNumber(costPerJob)}</CellRight>
            </tr>
        );
    }
);

export default DriverRow;
